module.exports = __webpack_public_path__ + "img/threechartsBt.17f8e985.png";